import React from 'react';
import { BrowserRouter as Router, Switch, Route, NavLink } from "react-router-dom";
import CorporateProfile from './about/CorporateProfile'
import Organisation from './about/Organisation'
import Clientele from './about/Clientele'
// import sideImage from '../images/lawyer-keywords.jpg'

function About() {
  window.scrollTo(0, 0);
  return (
    <Router>
      <div>
      <section className="ftco-section">
    <div className="container">
      <div className="row mb-5 mx-auto">
        <div className="col-md-3">
          <div style={{borderRadius:"8px",backgroundColor:"#5E5550"}}>
            <div>
            <img src="images/lawyer-keywords.jpg" style={{width:"100%",display: "block",marginLeft: "auto",marginRight: "auto",borderRadius:"8px 8px 0px 0px"}} alt="Logo" />
            </div>
            <ul className="navbar-nav" style={{marginLeft: "15px"}}>
              <li className="nav-item"><NavLink exact to="/about" className="nav-link" activeStyle={{color:"#b99566"}} style={{color:"#ffffff",fontFamily:"Perpetua Bold"}}><b>Corp Profile</b></NavLink></li>
              <li className="nav-item"><NavLink exact to="/organisation" className="nav-link" activeStyle={{color:"#b99566"}} style={{color:"#ffffff",fontFamily:"Perpetua Bold"}}><b>The Organisation</b></NavLink></li>
              <li className="nav-item"><NavLink exact to="/clientele" className="nav-link" activeStyle={{color:"#b99566"}} style={{color:"#ffffff",fontFamily:"Perpetua Bold"}}><b>Our Clientele</b></NavLink></li>
	          </ul>
          </div>
        </div>
        <div className="col-md-7">
        <Switch>
          <Route path="/about">
            <CorporateProfile />
          </Route>
          <Route path="/organisation">
            <Organisation />
          </Route>
          <Route path="/clientele">
            <Clientele />
          </Route>
        </Switch>
        </div>
      </div>
    </div>
  </section>
    </div>
    </Router>
  );
}

export default About;
